import { useCallback, useState } from 'react';

import { FilePenLine } from 'lucide-react'

import DefaultActions from '@/components/Grid/components/header/Actions';
import { useGrid } from '@Components/Grid/context';

import BulkInsert from './BulkInsert';

export default function HeaderButtons() {
  const { definitions: { defaultParams }, events: { handleSaveBulk } } = useGrid()
  const { allocation_id } = defaultParams || {}
  const [bulkOpen, setBulkOpen] = useState(false)

  const handleSave = useCallback(async payload => {
    const params = { allocation_id }
    await handleSaveBulk(payload, params)
  }, [handleSaveBulk, allocation_id])

  return <DefaultActions menu={[{ label: 'Bulk Edit', icon: FilePenLine, onSelect: () => setBulkOpen(true) }]}>
    <BulkInsert onSave={handleSave} open={bulkOpen} setOpen={setBulkOpen} />
  </DefaultActions>
}
